import service from "@/utils/request";

export function addBannerConfig(data) {
    return service({
        url: "/bannerConfigSimle/addBannerConfig",
        method: "post",
        params: data,
    });
}

export function updateBannerConfig(data) {
    return service({
        url: "/bannerConfigSimle/updateBannerConfig",
        method: "post",
        params: data,
    });
}

export function getBannerConfigInfo(data) {
    return service({
        url: "/bannerConfigSimle/getBannerConfigInfo",
        method: "get",
        params: data,
    });
}

export function getBannerConfigList(data) {
    return service({
        url: "/bannerConfigSimle/getBannerConfigList",
        method: "get",
        params: data,
    });
}

export function changeBannerConfigStatus(data) {
    return service({
        url: "/bannerConfigSimle/changeBannerConfigStatus",
        method: "get",
        params: data,
    });
}

export function deleteBannerConfig(data) {
    return service({
        url: "/bannerConfigSimle/deletBannerConfig",
        method: "get",
        params: data,
    });
}
